export const constants = {
  minimumStayParagraph:
    "All bookings have a 3-night minimum stay on weekends from August 28 - Sept. 7. We do accept shorter stays if we have gaps between existing reservations. Feel free to submit a request for a shorter weekend stay and we will let you know if we have a site available.",

  depositRates: {
    2026: {
      peak: {
        start: "2026-06-12",
        end: "2026-09-06",
        rates: {
          Unserviced: 54,
          "Regular Serviced": 66,
          "Premium Serviced": 77,
          "50 Amp": 80,
          Cabin: 112,
        },
      },

      value: {
        start: "2026-05-01",
        end: "2026-10-12",
        rates: {
          Unserviced: 44,
          "Regular Serviced": 54,
          "Premium Serviced": 64,
          "50 Amp": 67,
          Cabin: 91,
        },
      },
    },

    2027: {
      peak: {
        start: "2027-06-11",
        end: "2027-09-05",
        rates: {
          Unserviced: 54,
          "Regular Serviced": 66,
          "Premium Serviced": 77,
          "50 Amp": 80,
          Cabin: 112,
        },
      },

      value: {
        start: "2027-05-01",
        end: "2027-10-11",
        rates: {
          Unserviced: 44,
          "Regular Serviced": 54,
          "Premium Serviced": 64,
          "50 Amp": 67,
          Cabin: 91,
        },
      },
    },
  },
  bookingDates: {
    2026: {
      open: "2026-05-01",
      close: "2026-10-12",
    },

    2027: {
      open: "2027-05-01",
      close: "2027-10-11",
    },
  },
};
